const breakpoints = [320, 480, 768, 1024, 1200]; // [Mobiles, iPads, Small Screens + Laptops, Desktops + Large Screens, Extra Large Screen + TVs]

export const mq = breakpoints.map((bp) => `@media (min-width: ${bp}px)`);
